/**
 * @author caijianjia
 * @date 2024-05-30 20:24
 */
export default {
  loginBg: require('./loginBg.png'),
  indexBg: require('./indexBg.png'),
  searchBg: require('./searchBg.png'),
  indexSearch: require('./indexSearch.png'),
  newsBg: require('./newsBg.png'),
  leftMenuBg: require('./leftMenuBg.png'),
  leftMenuBg2: require('./leftMenuBg2.png'),
  leftMenuListBg: require('./leftMenuListBg.png'),
  catalogBg: require('./catalogBg.png'),
  aboutBg: require('./aboutBg.png'),
  serverBg: require('./serverBg.png'),
  footerContact: require('./footerContact.png'),
  footerPhone: require('./footerPhone.png'),
  footerEmail: require('./footerEmail.png'),
  footerLocation: require('./footerLocation.png'),
  step1: require('./step1.png'),
  step2: require('./step2.png'),
  step3: require('./step3.png'),
  platBg: require('./platBg.png'),
  btnSave: require('./btnSave.png'),
  upload: require('./upload.png'),
  indexItem: require('./indexItem.png'),
  indexDot: require('./indexDot.png'),
  indexImg: require('./indexImg.png'),
  indexItemLogo: require('./indexItemLogo.png'),
  applyImg: require('./applyImg.png'),
  applyFailIcon: require('./applyFailIcon.png'),
  applyFail: require('./applyFail.png'),
  applySuccessIcon: require('./applySuccessIcon.png'),
  applySuccess: require('./applySuccess.png'),
  pdfIcon: require('./pdfIcon.png'),
  applyImg1: require('./applyImg1.png'),
  applyImg2: require('./applyImg2.png'),
  applyImg3: require('./applyImg3.png'),
  man: require('./man.png'),
  peopleBg: require('./peopleBg.jpg')
}
